import axios from 'axios';

// Axios interceptor: ALWAYS send site context via x-site-id header AND URL param
axios.interceptors.request.use((config) => {
  // Skip for superadmin endpoints (they operate on master DB, not site-scoped)
  if (config.url && config.url.includes('/superadmin/')) return config;

  // Read site_id fresh from current URL on every request
  const urlSiteId = new URLSearchParams(window.location.search).get('site_id');
  if (urlSiteId) {
    if (!config.headers) config.headers = {};
    config.headers['x-site-id'] = urlSiteId;
    // Add site_id to URL params for unique cache key per site
    const separator = config.url && config.url.includes('?') ? '&' : '?';
    if (config.url && !config.url.includes('site_id=')) {
      config.url = `${config.url}${separator}site_id=${encodeURIComponent(urlSiteId)}`;
    }
    return config;
  }

  // Only use managed site context when on /admin pages
  if (window.location.pathname.startsWith('/admin')) {
    const managedSiteSlug = localStorage.getItem('managed_site_slug');
    const managedSiteId = localStorage.getItem('managed_site_id');
    if (managedSiteId && managedSiteSlug) {
      if (!config.headers) config.headers = {};
      config.headers['x-site-id'] = managedSiteSlug;
      const separator = config.url && config.url.includes('?') ? '&' : '?';
      if (config.url && !config.url.includes('site_id=')) {
        config.url = `${config.url}${separator}site_id=${encodeURIComponent(managedSiteSlug)}`;
      }
    }
  }

  return config;
});
